// Registers an overlay with the modal stack for as long as it is mounted, and
// hands back the check its key handlers should gate on.

import { useCallback, useEffect, useRef } from 'react';

import { isTopModalLayer, popModalLayer, pushModalLayer } from './modalStack';

export function useModalLayer(label: string): { isTopmost: () => boolean } {
  // Read at event time, not render time: the layer above this one can appear
  // or go away without re-rendering it.
  const idRef = useRef<symbol | null>(null);

  useEffect(() => {
    const id = pushModalLayer(label);
    idRef.current = id;
    return () => {
      popModalLayer(id);
      if (idRef.current === id) idRef.current = null;
    };
  }, [label]);

  const isTopmost = useCallback(() => idRef.current !== null && isTopModalLayer(idRef.current), []);

  return { isTopmost };
}
